import React from 'react';
import Alert from "v4/components/admin/Alert/Alert";
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import useCreateCoreLink from "v4/hooks/useCreateCoreLink";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import MicrosoftGraphConnection from "v4/features/admin/modules/components/ManageModules/components/MicrosoftGraphConnection/MicrosoftGraphConnection";
import useMicrosoftGraphConnection from "v4/features/admin/modules/components/ManageModules/hooks/useMicrosoftGraphConnection";
import './ManageModules.scss';

export default function ManageModules({customerId}) {
    const {t} = usePolTranslation();

    const coreModulesLink = useCreateCoreLink(`admin/customers/${customerId}/modules`);
    const microsoftGraphConnection = useMicrosoftGraphConnection(customerId);

    return (
        <AdminCard title={t("manage_modules")}>
            <Alert
                type="warning"
                title={t('warning')}
                message={t('core_moved_config')}
            >
                <a href={coreModulesLink}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="manage-modules__core-link"
                >
                    {coreModulesLink}
                </a>
            </Alert>
            {microsoftGraphConnection && (
                <div className="d-flex justify-content-center my-3">
                    <MicrosoftGraphConnection url={microsoftGraphConnection.url} tenantId={microsoftGraphConnection.tenantId}/>
                </div>
            )}
        </AdminCard>
    )
}
